import script from "./valentinesday.vue?vue&type=script&lang=ts&setup=true"
export * from "./valentinesday.vue?vue&type=script&lang=ts&setup=true"

import "./valentinesday.vue?vue&type=style&index=0&id=edd3ab58&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edd3ab58"]])

export default __exports__